import { OpenModalService } from './../common-theme/base-components/shared/modals/open-modal.service';
import { Component, OnInit, Injector } from '@angular/core';
import { BaseComponent } from '../common-theme/base-components/base-component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { Image } from './../common-theme/models/index';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})

export class PartnersComponent extends BaseComponent implements OnInit {
  partners: any[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    injector: Injector,
    public translateService: TranslateService,
    private openModalService: OpenModalService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.partners = this.getPartners();

    this.subscription.add(this.translateService.onLangChange
      .subscribe(() => {
        this.partners = this.getPartners();
      })
    );

    this.setTitle('Partenerii proiectului Romanescu Park Residence');

    this.setMetaDescription(`
      Recunoștință este o valoare importantă, de care nu uităm niciodată. De aceea, le mulțumim
      partenerilor proiectului nostru pentru tot sprijinul acordat: Dobrescu Arh, Real Sol, CPM și Maur -
      toate fiind companii de prestigiu, cu experiență în construirea proiectelor imobiliare inedite.
    `);
  }

  getPartners(): any {
    const partners = [];

    for (let i = 0; i <= 4; i++) {
      const partner = {
        title: '',
        role: '',
        content: '',
        image: {
          url: ''
        },
        link: ''
      };

      this.translateSubscription.add(
        this.translateService.get('partners.' + i + '.title')
          .subscribe((translatedString: string) => {
            partner.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('partners.' + i + '.role')
          .subscribe((translatedString: string) => {
            partner.role = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('partners.' + i + '.content')
          .subscribe((translatedString: string) => {
            partner.content = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('partners.' + i + '.link')
          .subscribe((translatedString: string) => {
            partner.link = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('partners.' + i + '.image.url')
          .subscribe((translatedString: string) => {
            partner.image.url = translatedString;
          })
      );

      partners.push(partner);
    }

    return partners;
  }

  openPartnerModal(item: any): void {
    const image = new Image();
    image.width_320_url = item.image.url;

    this.openModalService.showPartnersContent({
      id: 0,
      name: item.title,
      description: item.content,
      image: image,
      link: item.link
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.ts